import * as React from "react";
import {ResponsiveViewRule, ReadingSystemEngine } from "../libs/framework/colibrio-readingsystem-engine";
import { EpubFormatAdapter } from "../libs/framework/colibrio-readingsystem-formatadapter-epub";
import { OcfResourceProvider } from "../libs/framework/colibrio-core-publication-epub";
import { HttpDataSource } from "../libs/HttpDataSource";
import {  FlipBookRenderer, StackRenderer } from "../libs/framework/colibrio-readingsystem-renderer";
import Auth from "@aws-amplify/auth";
import Storage from "@aws-amplify/storage";
import config from "../config";


export default class PublicationLoader extends React.Component{
  constructor(props) {
    super(props);
    this.backgroundColor = "#FFFFFF"
    this.epubTitle = ""
    this.epubFormat= ""
    this.renderer = "flipbookRenderer"
    this.colorTheme = "Default"
    this.fontTheme = "Default"
  }

   async loadFile (fileName)  {
    if (typeof window !== `undefined` && typeof document !== `undefined`  ) {
    try {
      this.engine = new ReadingSystemEngine();
      const allFiles = await Storage.list("" ,{bucket: config.s3.BUCKET, level: "private" })
      const currentFile = allFiles.filter(item => item.key === fileName);
      if (currentFile.length < 0 ) {
        throw new Error("No file found");
      }
      this.engine.addFormatAdapter(new EpubFormatAdapter());
      let user = await Auth.currentUserInfo();
      let username = user.id;
      const remoteEpub = new HttpDataSource("https://s3.amazonaws.com/"+config.s3.BUCKET+"/private/"+username+"/"+fileName, currentFile[0].size);
      const ocfResourceProvider = await OcfResourceProvider.createFromRandomAccessDataSource(remoteEpub);
      const epubPublication = ocfResourceProvider.getDefaultPublication();
      if (!epubPublication) {
          throw new Error("No publication found in this EPUB file :(");
      }
      this.epubFormat = epubPublication.getDefaultLayout();
      this.readerPublication = await this.engine.loadPublication(epubPublication);
      this.view = this.engine.createView({
        enablePointerEventListener: true,
        viewInteractionPointerTypes: {
            touch: true
        }
      });
      const flipBook = new FlipBookRenderer({
          name: "flipbookRenderer",
          disableAnimations: false
      });
      this.view.addRenderer(flipBook, new ResponsiveViewRule("(min-width: 600px)"));
      const stackRenderer= new StackRenderer({
          name: "stackRenderer",
          disableAnimations: false
      });
      this.view.addRenderer(stackRenderer, new ResponsiveViewRule("(max-width: 599px)"));

      const readerDocuments = this.readerPublication.getSpine().filter(readerDocument => {
          return readerDocument.getSourceContentDocument().isInLinearContent();
      });
      this.view.setReaderDocuments(readerDocuments);
      let titles = this.readerPublication.getSourcePublication().getMetadata().getTitles()
      if (titles[0]) {
           this.epubTitle = titles[0].title;
      }
    } catch (e) {
      console.log(e);
    }
}
  }

 getEngine() {
    return this.engine;
  }
 getReaderPublications() {
    return this.readerPublication;
  }
 getView() {
    return this.view;
  }
 getTimeline(){
    return this.view.getTimeline()
  }
}
